export enum MANAGEMENT_TYPES {
  GET_DATA_TABLE = '@management/GET_DATA_TABLE',
  CLEAR_DATA_TABLE = '@management/CLEAR_DATA_TABLE',
  SET_DATA_TABLE = '@management/SET_DATA_TABLE',
  SET_FILTER_STATUS_TABLE = '@management/SET_FILTER_STATUS_TABLE',
  SET_FILTER_DATE_TABLE = '@management/SET_FILTER_DATE_TABLE',
}

export interface ManagementState {
  movement: any;
  status: any;
}

export interface SagaTable {
  table: 'tableA' | 'tableB' | 'tableC';
  type: 'status' | 'movement';
  filter: any;
}
